import Reveal from "@/components/Reveal";
import { WHO_WAS_NICK } from "@/lib/the190";
import { track } from "@/lib/analytics";

/* --------------------------------- HERO --------------------------------- */
/* Editorial split: pair photograph (55–60%) alongside collector copy. */

export const Hero190 = () => {
  const scroll = (id) => {
    track("cta_click", { cta: `hero-${id}` });
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="the-190-top"
      data-testid="the190-hero"
      className="relative w-full bg-[color:var(--bone)] text-[color:var(--ink)] pt-28 md:pt-24 pb-16 md:pb-0"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center min-h-[calc(100svh-6rem)]">
        {/* Image — mobile above, desktop right (58%) */}
        <div className="md:col-span-7 md:order-2">
          <Reveal slow>
            <figure className="relative">
              <picture>
                <source srcSet="/collector/pair-on-floor.webp" type="image/webp" />
                <img
                  src="/collector/pair-on-floor.jpg"
                  alt="Tribal Goddess and Universal Soul of Stars — the two Chapter II Collector Editions by Nick Fraser, presented as framed archival giclée prints"
                  className="w-full h-auto block"
                  data-testid="the190-hero-image"
                  loading="eager"
                />
              </picture>
            </figure>
          </Reveal>
        </div>

        {/* Copy — mobile below, desktop left (42%) */}
        <div className="md:col-span-5 md:order-1 md:pr-6">
          <Reveal delay={140}>
            <p className="hairline opacity-55 mb-8" data-testid="the190-hero-eyebrow">
              Nick Fraser Archive
            </p>
            <h1
              className="font-wordmark leading-[0.9] tracking-wide text-[13vw] md:text-[6.2vw] lg:text-7xl"
              data-testid="the190-title"
            >
              Collector
              <br />
              Editions
            </h1>
            <p
              className="font-serif italic text-xl md:text-2xl leading-[1.45] opacity-90 mt-10 max-w-md"
              data-testid="the190-subheadline"
            >
              A limited series of signed and numbered editions drawn from Nick
              Fraser&apos;s archive.
            </p>
            <p className="font-serif italic text-base md:text-lg leading-[1.55] opacity-70 mt-6 max-w-md">
              Created in connection with Chapter II at Shoreditch Arts Club, each
              edition forms part of a strictly limited edition of 100 and is
              accompanied by a Certificate of Authenticity.
            </p>
            <div className="mt-12">
              <button
                type="button"
                onClick={() => scroll("edition-tribal-goddess")}
                className="hairline bg-[color:var(--ink)] text-[color:var(--bone)] px-8 py-4 hover:bg-[color:var(--oxblood)] transition-colors duration-500"
                data-testid="the190-hero-explore"
              >
                Explore the Editions
              </button>
            </div>
            <p className="hairline opacity-55 mt-10 leading-relaxed" data-testid="the190-hero-spec">
              Signed &nbsp;·&nbsp; Numbered &nbsp;·&nbsp; Edition of 100 &nbsp;·&nbsp; Certificate of Authenticity
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

/* ------------------------ WHO WAS NICK — biographical ------------------------ */

export const AboutNick = () => (
  <section
    id="story"
    className="dark-section py-28 md:py-44"
    data-testid="the190-story"
    style={{ scrollMarginTop: 80 }}
  >
    <div className="max-w-[1500px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-start">
        <Reveal className="md:col-span-5" slow>
          <figure>
            <img
              src="/hero/nick-portrait.jpg"
              alt="Nick Fraser — East London artist, 1946 to 2023"
              loading="lazy"
              className="w-full h-auto block"
              data-testid="the190-nick-portrait"
            />
            <figcaption className="hairline opacity-55 mt-4">Nick Fraser · 1946 — 2023</figcaption>
          </figure>
        </Reveal>
        <Reveal className="md:col-span-7 md:pt-8" delay={140}>
          <p className="hairline opacity-60 mb-6">The Artist</p>
          <h2 className="font-wordmark text-5xl md:text-7xl leading-[1.02]">
            Who was Nick Fraser?
          </h2>
          <div className="mt-10 space-y-6 max-w-2xl">
            {WHO_WAS_NICK.map((p, i) => (
              <p key={i} className="font-serif italic text-xl md:text-2xl leading-[1.45] opacity-85">
                {p}
              </p>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Hero190;
